package com.anjuros.website.templates.template2.modules


import com.anjuros.website.templates.template2.util.ResKey

enum class Template2Reason(
    val icon: String,
    val title: ResKey,
    val description: ResKey
) {

    EXPERIENCE(
        icon = "template2_about1.svg",
        title = ResKey.TEMPLATE2_INFO_TITLE1,
        description = ResKey.TEMPLATE2_INFO_DESC1
    ),


    QUALITY(
        icon = "template2_about2.svg",
        title = ResKey.TEMPLATE2_INFO_TITLE3,
        description = ResKey.TEMPLATE2_INFO_DESC3
    ),
    HONEST(
        icon = "template2_about3.svg",
        title = ResKey.TEMPLATE2_INFO_TITLE2,
        description = ResKey.TEMPLATE2_INFO_DESC2
    ),

    LOCAL(
        icon = "template2_about4.svg",
        title = ResKey.TEMPLATE2_INFO_TITLE4,
        description = ResKey.TEMPLATE2_INFO_DESC4
    )

}